import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {INFOCENTER_ROUTES} from "@constants"
import InfoCenterGeneralPage from "./General";
import InfoCenterKpiGlossaryPage from "./KpiGlossary";
import InfoCenterRetailersTrackedPage from "./RetailersTracked";


export const InfoCenterRoutes = {
    title: INFOCENTER_ROUTES.TITLE,
    path: INFOCENTER_ROUTES.PATH,
    accessKey: INFOCENTER_ROUTES.ACCESS_KEY,
    icon: 'file-magnifying-glass',
    element: <AppLayout />,
    description: INFOCENTER_ROUTES.SUBTITLE,
    children: [
        { element: <Navigate to={INFOCENTER_ROUTES.GENERAL_PATH} replace />, index: true },
        { title: INFOCENTER_ROUTES.GENERAL_TITLE, path: INFOCENTER_ROUTES.GENERAL_PATH, dashboardKey: INFOCENTER_ROUTES.GENERAL_ID, element: <InfoCenterGeneralPage /> },
        { title: INFOCENTER_ROUTES.RETAILERS_TRACKED_TITLE, path: INFOCENTER_ROUTES.RETAILERS_TRACKED_PATH, dashboardKey: INFOCENTER_ROUTES.RETAILERS_TRACKED_ID, element: <InfoCenterRetailersTrackedPage /> },
        { title: INFOCENTER_ROUTES.KPI_GLOSSARY_TITLE, path: INFOCENTER_ROUTES.KPI_GLOSSARY_PATH, dashboardKey: INFOCENTER_ROUTES.KPI_GLOSSARY_ID, element: <InfoCenterKpiGlossaryPage /> }
    ]
}